import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { AuthModuleData } from '../types';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import _ from 'lodash';
import type { AuthModel } from '../auth.model';

@injectable()
export class AuthModelImpl extends AbstractModel<AuthModuleData> implements AuthModel {
    _modelData: AuthModuleData = {
        isShare: false,
        isLogin: false,
        ownerName: '',
    };

    constructor(
    ) {
        super();
    }

    public updateModuleData(getUpdateModuleValue: (value: AuthModuleData) => AuthModuleData) {
        this.update(getUpdateModuleValue);
    }
}
